import { memo } from "react";
import { Loader2 } from "lucide-react";
import { Typography } from "@/components/Typography";
import { cn } from "@/lib/utils";

export type SpinLoadingProps = {
  text?: string;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
};

export const SpinLoading = memo(function SpinLoading({
  text,
  className,
  iconClassName,
  textClassName,
}: SpinLoadingProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2.5 py-5",
        className,
      )}
    >
      <Loader2
        className={cn("size-7 animate-spin text-primary", iconClassName)}
      />
      {text ? (
        <Typography
          variant="body2"
          className={cn("text-body", textClassName)}
        >
          {text}
        </Typography>
      ) : null}
    </div>
  );
});

export default SpinLoading;
